<template>
    <header class="header">
        <!--start navbar-->
        <nav
            class="navbar navbar-expand-lg fixed-top"
            v-bind:class="{
                affix: hasAffix,
                'custom-nav': coloredLogo,
                'bg-transparent': !coloredLogo,
                'white-bg': coloredLogo,
            }"
        >
            <div class="container">
                   <router-link
                                class="navbar-brand"
                                to="/"
                                ><img
                        :src="'img/logo-white-1x.png'"
                        :width="logoWidth"
                        alt="logo"
                        class="img-fluid pb-4"
                /></router-link>
               

                <button
                    class="navbar-toggler"
                    type="button"
                    @click="mobileNavClicked"
                    v-bind:class="{ collapsed: collapsed }"
                >
                    <span class="ti-menu"></span>
                </button>

                <div
                    class="collapse navbar-collapse main-menu h-auto"
                    v-bind:class="{ show: !collapsed }"
                    id="navbarSupportedContent"
                >
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item dropdown bold">
                            <v-btn text @click='()=>{$router.push("/")}'>{{$t('home')}}</v-btn>
                        </li>
                        <li class="nav-item nav-link page-scroll">
                            <v-btn text @click='()=>{$router.push("/about")}'>{{$t('AboutUs')}}</v-btn>
                        </li>
                        <li class="nav-item">
                            <v-btn text @click='()=>{$router.push("/services")}'>{{$t('OurServices')}}</v-btn>
                        </li>
                        <li class="nav-item">
                            <v-btn text @click='()=>{$router.push("/join")}'>{{$t('JoinUs')}}</v-btn>
                        </li>
                        <li class="nav-item">
                            <v-btn text @click='()=>{$router.push("/confinementservice")}'>{{$t('confinementNanny')}}</v-btn>
                        </li>
                        <li class="nav-item">
                            <v-btn text @click='()=>{$router.push("/relatedVideo")}'>{{$t('relatedVideo')}}</v-btn>
                        </li>
                        <li class="nav-item">
                            <v-btn text @click='()=>{$router.push("/recipes")}'>{{$t('recipes')}}</v-btn>
                        </li>
                        <li class="nav-item">
                            <v-btn text @click='()=>{$router.push("/contact")}'>{{$t('ContactUs')}}</v-btn>
                        </li>
                        <li class="nav-item">
                            <a @click='()=>{$router.push("/matching")}' class="nav-cta-pill">
                                {{$t('Matching')}}
                            </a>
                        </li>
                    </ul>
                    <div class="locale-switcher">
                        <a @click="changeLocale('zh-HK')">繁</a>
                        <span>|</span>
                        <a @click="changeLocale('en')">Eng</a>
                    </div>
                </div>
                
            </div>
        </nav>
        <!--end navbar-->
    </header>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
export default {
    props: {
        coloredLogo: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            windowTop: 0,
            collapsed: true,
        };
    },
    mounted() {
        window.addEventListener("scroll", this.onScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.onScroll);
    },
    methods: {
         changeLocale(locale) {
           
        this.language = locale;
    },
        onScroll: function () {
            this.windowTop = window.top.scrollY;
        },
        mobileNavClicked: function () {
            this.collapsed = !this.collapsed;
        },
    },
    computed: {
        ...mapFields(['language']),
        hasAffix() {
            return this.windowTop > 0;
        },
        logoWidth() {
            return this.$i18n.locale === 'en' ? 420 : 312;
        },
    },
};
</script>
<style scoped>
.bold {
    font-weight: bold;
}

.nav-cta-pill {
    display: inline-flex;
    align-items: center;
    background: #0A7A76;
    color: #fff !important;
    font-size: 13px;
    font-weight: 700;
    padding: 8px 20px;
    border-radius: 50px;
    cursor: pointer;
    transition: background 0.25s, transform 0.2s;
    white-space: nowrap;
}
.nav-cta-pill:hover {
    background: #085E5B;
    transform: translateY(-1px);
    color: #fff !important;
    text-decoration: none;
}

.locale-switcher {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-left: 16px;
    color: rgba(255,255,255,0.7);
    font-size: 13px;
}
.locale-switcher a {
    cursor: pointer;
    color: rgba(255,255,255,0.85);
    font-weight: 500;
    transition: color 0.2s;
}
.locale-switcher a:hover {
    color: #ffffff;
}
.locale-switcher span {
    color: rgba(255,255,255,0.4);
}
</style>

